import React, { useState } from 'react';
import { NcziEnum } from '../../../../../graphql/graphql';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import NZCIListItem from '../../Base/NZCIListItem';
import VerifyVersionModal from '../VerifyModal/VerifyVersionModal';

//@ts-ignore
import styles from './EnumListItem.module.scss';

interface Props {
	item: NcziEnum;
}

const EnumListItem: React.FC<Props> = props => {
	const { item } = props;
	const [ verifyOpen, setVerifyOpen ] = useState<boolean>(false);

	const isMeddi = !item.oid.startsWith('1.3.158.00165387');

	const handleVerifyVersion = () => {
		if(isMeddi) {
			return;
		}

		setVerifyOpen(true);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.border}>
				<div className={styles.content}>
					<div className={styles.header}>
						<div className={styles.openEntryName}>
							{item.name}
						</div>
					</div>
					<div className={styles.itemInfo}>
						<NZCIListItem title={'OID'} value={item.oid} extra={isMeddi ? 'MEDDI' : 'NCZI'} />
					</div>
				</div>
				<div className={styles.version}>
					v{item.version}
				</div>
				<div className={styles.controls}>
					<LinkButton
						title={'nczi.verifyVersion'}
						theme={isMeddi ? Theme.DISABLED : Theme.BLUE}
						onClick={handleVerifyVersion}
					/>
				</div>
			</div>
			<VerifyVersionModal item={item} onClose={() => setVerifyOpen(false)} opened={verifyOpen} />
		</div>
	);
};

export default EnumListItem;
